
export type PlanId = '0' | '3' | '6' | '12';
type SubscriptionStatus = 'active' | 'current' | 'canceled';

export type SubscriptionState = {
    type: 'keepCurrentUI' | 'treatAsFree' | 'showAsCanceled';
    shouldShowInfo: boolean;
    endDate: number | null;
    isCanceled?: boolean;
};

export type SubscriptionOption = {
    id: PlanId;
    planKey: string;
    months: string;
    period: string;
    price: string;
    discountPrice?: string;
    periodText: string;
    popular: boolean;
    features: string[];
};

export type SubscriptionDetails = {
    status: SubscriptionStatus;
    cancel_at?: number;
};


export const PLAN_HIERARCHY: Record<PlanId, number> = {
    '0': 0,
    '3': 3,
    '6': 6,
    '12': 12
};

export const PLANS: Record<PlanId, Omit<SubscriptionOption, 'popular' | 'features'>> = {
    '0': {
        id: '0',
        planKey: '',
        months: 'Gratis',
        period: '',
        price: '0 €',
        periodText: '/ Monat'
    },
    '3': {
        id: '3',
        planKey: 'silver+ 3 Monate Mindestlaufzeit',
        months: '3 Monate',
        period: 'Mindestlaufzeit',
        price: '13,99 €',
        discountPrice: '19,99 €',
        periodText: '/ Monat'
    },
    '6': {
        id: '6',
        planKey: 'silver+ 6 Monate Mindestlaufzeit',
        months: '6 Monate',
        period: 'Mindestlaufzeit',
        price: '9,99 €',
        discountPrice: '13,99 €',
        periodText: '/ Monat'
    },
    '12': {
        id: '12',
        planKey: 'silver+ 12 Monate Mindestlaufzeit',
        months: '12 Monate',
        period: 'Mindestlaufzeit',
        price: '6,99 €',
        discountPrice: '8,99 €',
        periodText: '/ Monat'
    }
};

export const FEATURES = {
    "0": ['Zugriff auf silvertalent Jobangebote'],
    paid: [
        'Zugriff auf silvertalent Jobangebote',
        'Ihre Nachrichten immer oben im Postfach der Arbeitgeber',
        'Alle Teilzeit-Jobangebote aus dem Web',
        'Persönliche Anschreiben für jede Bewerbung',
        'Digitales Bewerbungsgespräch-Training',
        'Digitaler Jobcoach zur Stärkenanalyse und Berufsorientierung',
    ]
};

export const MESSAGES = {
    errors: {
        payment: 'Fehler beim Zahlungsvorgang',
        paymentDescription: 'Es ist ein Fehler beim Starten des Zahlungsvorgangs aufgetreten.',
        authRequired: 'Anmeldung erforderlich',
        authDescription: 'Bitte melden Sie sich an, um fortzufahren.'
    },
    buttons: {
        currentPlan: 'Ihr aktueller Tarif',
        switchToFree: 'Zu Gratis wechseln',
        notAvailable: 'Nicht verfügbar',
        proceedToPayment: 'Weiter zur Bezahlung',
        manageSubscription: 'Abonnement verwalten'
    },
    tooltips: {
        downgradeTiming: (endDate: string) =>
            `Sie können nach der Mindestlaufzeit (bis ${endDate}) zum kostenlosen Plan wechseln, indem Sie Ihr Abonnement kündigen.`,
        downgradeRestriction: 'Downgrades sind während der aktiven Laufzeit nicht möglich. Sie können nur zu längeren Laufzeiten wechseln.'
    }
};

